import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/styles/base.css";
import "../../assets/styles/buttons.css";
import "../../assets/styles/counter.css";
import "../../assets/styles/footer.css";
import "../../assets/styles/hero.css";
import "../../assets/styles/nav.css";
import "../../assets/styles/parallax.css";
import "../../assets/styles/template.css";
import "../../assets/styles/tile.css";
import "../../assets/styles/video.css";

import Footer from "./Footer";
import { HOME } from "./nav/NavigationItems";
import Header from "./Header";
import Navigation from "./nav/Navigation";
import React from "react";
import ScrollButton from "./ux/buttons/ScrollButton";
import Seo from "./Seo";
import SocialLinks from "./ux/buttons/SocialLinks";

const Layout = ({ page, children, ...props }) => {
  return (
    <>
      <Seo title={page} />
      <Navigation page={page} />
      <Header page={page} src={props.src} alt={props.alt} />
      <main
        style={{
          marginTop: [HOME].includes(page) ? "87vh" : "79.5vh",
          marginBottom: [HOME].includes(page) ? "-7em" : undefined,
        }}
        className={[HOME].includes(page) ? "dynamic-top" : undefined}
      >
        {children}
      </main>
      <Footer />
      <SocialLinks />
      <ScrollButton />
    </>
  );
};

export default Layout;
